import { render } from "./fotito.vue?vue&type=template&id=370cde28&scoped=true"
import script from "./fotito.vue?vue&type=script&lang=js"
export * from "./fotito.vue?vue&type=script&lang=js"

import "./fotito.vue?vue&type=style&index=0&id=370cde28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-370cde28"]])

export default __exports__